module.exports = __webpack_public_path__ + "static/media/video.3c5b5daa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero/video.mp4
// module id = 28
// module chunks = 0